export default function HeroSection() {
  return (
    <section
      id="hero"
      className="relative min-h-screen flex items-center pt-[72px] overflow-hidden bg-background-50"
    >
      <div className="absolute inset-0 overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=Cinematic%20movie%20theater%20interior%20with%20warm%20golden%20ambient%20lighting%20red%20velvet%20curtains%20film%20projector%20beam%20artistic%20abstract%20style%20soft%20bokeh%20background%20elegant%20warm%20tones%20atmospheric%20depth&width=1800&height=1000&seq=hero-bg-01&orientation=landscape"
          alt="四虎影视大全电影盛宴背景"
          className="w-full h-full object-cover object-top opacity-60"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/30 to-black/55"></div>
      </div>

      <div className="relative w-full px-4 md:px-6 py-12 md:py-20">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-500/15 border border-primary-500/25 mb-5">
              <span className="w-2 h-2 rounded-full bg-primary-500 animate-pulse"></span>
              <span className="text-xs font-medium text-primary-600 whitespace-nowrap">每日更新 · 高清免费</span>
            </div>

            <h1 className="font-heading text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-black text-white leading-tight mb-4">
              四虎影视大全
              <br />
              <span className="text-accent-400">海量高清电影免费在线</span>
            </h1>

            <p className="text-base md:text-lg text-white/80 leading-relaxed max-w-xl mx-auto lg:mx-0 mb-4">
              四虎影视大全电影大全频道，汇集20000+部全球优质影片，从最新院线大片到经典修复佳作，从国产热门到海外精选，类型覆盖全面、每日更新不断。无需注册付费，打开即看，1080P高清画质搭配极速加载，为你打造纯粹的电影盛宴。
            </p>
            <p className="text-sm md:text-base text-white/70 leading-relaxed max-w-xl mx-auto lg:mx-0 mb-6">
              当前暑期档专题"盛夏光影"热映中，科幻巨制《流浪地球3》全网首发高清，悬疑专题"暗夜迷踪"同步上线——无论你想燃爆肾上腺素还是享受温情时光，四虎影视大全都已为你准备好了最佳片单。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-3 md:gap-4 mb-8">
              <div className="flex items-center gap-2 px-3 py-1.5 rounded-lg bg-white/10 backdrop-blur-sm">
                <i className="ri-movie-2-line text-accent-400 text-sm"></i>
                <span className="text-xs md:text-sm text-white/80 whitespace-nowrap">20000+ 部影片</span>
              </div>
              <div className="flex items-center gap-2 px-3 py-1.5 rounded-lg bg-white/10 backdrop-blur-sm">
                <i className="ri-4k-line text-accent-400 text-sm"></i>
                <span className="text-xs md:text-sm text-white/80 whitespace-nowrap">每日更新 50+ 部</span>
              </div>
              <div className="flex items-center gap-2 px-3 py-1.5 rounded-lg bg-white/10 backdrop-blur-sm">
                <i className="ri-shield-check-line text-accent-400 text-sm"></i>
                <span className="text-xs md:text-sm text-white/80 whitespace-nowrap">安全纯净观影</span>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#ranking"
                className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-8 py-3.5 bg-primary-500 hover:bg-primary-600 text-white font-semibold rounded-lg transition-colors whitespace-nowrap text-sm md:text-base cursor-pointer"
              >
                <i className="ri-fire-fill text-lg"></i>
                查看热播榜单
              </a>
              <a
                href="#cards"
                className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-8 py-3.5 bg-white/10 hover:bg-white/20 backdrop-blur-sm text-white font-semibold rounded-lg border border-white/20 transition-colors whitespace-nowrap text-sm md:text-base cursor-pointer"
              >
                <i className="ri-compass-3-line text-lg"></i>
                探索电影分类
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-lg lg:max-w-none">
            <div className="relative">
              <div className="absolute -inset-4 bg-gradient-to-r from-primary-500/20 via-accent-500/15 to-primary-500/20 rounded-2xl blur-2xl"></div>
              <div className="relative rounded-xl overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Cinematic%20film%20reel%20and%20movie%20elements%20artistic%20composition%20warm%20golden%20and%20red%20tones%20dramatic%20lighting%20vintage%20cinema%20aesthetic%20elegant%20movie%20poster%20style%20rich%20texture%20professional%20photography&width=900&height=1100&seq=hero-visual-01&orientation=portrait"
                  alt="四虎影视大全电影视觉"
                  className="w-full h-auto object-cover"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}